export default __webpack_public_path__ + "static/media/socialFriends.1077f933.svg";